{
  "pt": {
    "analytics": {
      "labels": {
        "click_seen_by": "Clique para ver quais os clientes que viram isto",
        "click_shared_with": "Clique para ver quais os clientes que viram isto",
        "deleted": "Eliminado",
        "deleted_item": "Este item foi eliminado e já não pode ser clicado",
        "noCustomers": "Ainda não há clientes atribuídos a este nível.",
        "noCustomersSeen": "Nenhum cliente viu isto ainda.",
        "noCustomersUnseen": "Todos os clientes já viram isto.",
        "noUnitAccess": "Sem acesso à unidade",
        "notSeen": "Não Visto ({number})",
        "seen": "Visto ({number})",
        "seenBy": "Visto por",
        "sharedWithMultipleUnits": "Partilhado sem unidades em {level_name} | Partilhado com 1 unidade em {level_name} | Partilhado com {units_count} unidades em {level_name}",
        "sharedWithUnit": "Partilhado com {unit_name}",
        "units": "Nenhuma unidade | Uma unidade | {count} Unidades",
        "views": "Vistas",
        "viewsCount": "Nenhuma visualização | 1 visualização | {count} visualizações"
      }
    }
  }
}